import MessageModal from "../../component/MessageModal";

const PaymentSuccess = () => {
  return <MessageModal message="Payment Success" />;
};

export default PaymentSuccess;
